import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '@/lib/api';
import { useAuth } from '@/lib/auth-context';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS,
// THIS BREAKS THE AUTH (Emergent Google OAuth flow).
export default function AuthCallback() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || '';
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate('/login');
      return;
    }
    const sessionId = decodeURIComponent(match[1]);

    (async () => {
      try {
        await api.post('/auth/google-session', { session_id: sessionId });
        await refresh();
        // Clean hash & redirect home
        window.history.replaceState(null, '', window.location.pathname);
        navigate('/');
      } catch {
        navigate('/login');
      }
    })();
  }, [navigate, refresh]);

  return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <div className="text-center">
        <div className="w-8 h-8 border-2 border-slate-200 border-t-[#1E3A8A] rounded-full animate-spin mx-auto mb-4" />
        <p className="text-sm text-slate-500">Completing sign-in…</p>
      </div>
    </div>
  );
}
